/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateClassRoomRequest
 */
export interface UpdateClassRoomRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateClassRoomRequest
     */
    classRoomId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRoomRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClassRoomRequest
     */
    description: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClassRoomRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateClassRoomRequest
     */
    locationId: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the UpdateClassRoomRequest interface.
 */
export function instanceOfUpdateClassRoomRequest(value: object): value is UpdateClassRoomRequest {
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    return true;
}

export function UpdateClassRoomRequestFromJSON(json: any): UpdateClassRoomRequest {
    return UpdateClassRoomRequestFromJSONTyped(json, false);
}

export function UpdateClassRoomRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClassRoomRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classRoomId': ApiUserTasksGetPageParameterFromJSON(json['classRoomId']),
        'name': json['name'],
        'description': json['description'],
        'isActive': json['isActive'],
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
    };
}

export function UpdateClassRoomRequestToJSON(json: any): UpdateClassRoomRequest {
    return UpdateClassRoomRequestToJSONTyped(json, false);
}

export function UpdateClassRoomRequestToJSONTyped(value?: UpdateClassRoomRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classRoomId': ApiUserTasksGetPageParameterToJSON(value['classRoomId']),
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
    };
}

